<nb-card class="lms-page">
  <nb-card-header>
    <div class="lms-header">
      <div class="lms-header__intro">
        <h4>{{ 'pages.tutors.lmsRegistrations.title' | translate }}</h4>
        <p class="lms-header__hint">
          {{ 'pages.tutors.lmsRegistrations.hint' | translate }}
        </p>
      </div>
      <button nbButton status="primary" size="small" (click)="openLtiWizard()">
        <nb-icon icon="link-2-outline"></nb-icon>
        {{ 'pages.tutors.lmsRegistrations.setupLti' | translate }}
      </button>
    </div>
  </nb-card-header>

  <nb-card-body>
    <div *ngIf="loading" class="lms-loading">
      <nb-spinner status="basic"></nb-spinner>
    </div>

    <table *ngIf="!loading" class="lms-table">
      <thead>
        <tr>
          <th>{{ 'pages.tutors.lmsRegistrations.col.name' | translate }}</th>
          <th>{{ 'pages.tutors.lmsRegistrations.col.identifier' | translate }}</th>
          <th>{{ 'pages.tutors.lmsRegistrations.col.lastSeen' | translate }}</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let r of registrations">
          <td>
            <strong>{{ r.display_name }}</strong>
          </td>
          <td>
            <span class="lms-table__issuer">{{ r.lti_issuer }}</span>
            <small class="lms-table__client">
              Client ID: {{ r.lti_client_id }}
              <span
                *ngIf="r.lti_client_id === 'pending'"
                class="source-badge source-badge--pending"
                [nbTooltip]="'pages.tutors.lmsRegistrations.pendingHint' | translate"
                nbTooltipPlacement="top"
              >{{ 'pages.tutors.lmsRegistrations.pendingBadge' | translate }}</span>
            </small>
          </td>
          <td>{{ r.last_seen_at ? (r.last_seen_at | date: 'short') : '—' }}</td>
          <td class="lms-table__center lms-table__actions">
            <a
              *ngIf="r.lti_client_id !== 'pending'"
              nbButton
              ghost
              size="small"
              status="primary"
              routerLink="/tutors/placements"
              [queryParams]="{ tab: 'lti' }"
              [nbTooltip]="'pages.tutors.lmsRegistrations.placements' | translate"
              nbTooltipPlacement="top"
            >
              <nb-icon icon="grid-outline"></nb-icon>
            </a>
            <button nbButton ghost size="small" status="danger" (click)="deleteRegistration(r)">
              <nb-icon icon="trash-2-outline"></nb-icon>
            </button>
          </td>
        </tr>
        <tr *ngIf="registrations.length === 0">
          <td colspan="4" class="lms-empty">
            <p>{{ 'pages.tutors.lmsRegistrations.empty' | translate }}</p>
            <button nbButton status="primary" size="small" (click)="openLtiWizard()">
              <nb-icon icon="link-2-outline"></nb-icon>
              {{ 'pages.tutors.lmsRegistrations.setupLti' | translate }}
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </nb-card-body>
</nb-card>
